module.exports = __webpack_public_path__ + "static/media/BrixSans-Light.83d2ff64.eot";